module.exports = "../../app/cells/pages/questions/renewal_time_box_cell.rb";